document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const menuToggle = event.target.closest('.header__icon--summary');

    if (!menuToggle) return;

    const details = menuToggle.closest('details');
    const isMobile = window.matchMedia('(max-width: 989px)').matches;

    if (details && details.open) {
      // currently open → about to close
      document.body.classList.remove('menu-drawer-open');
      document.body.classList.remove('homepage-header-past-hero');

      if (window.updateHomepageHeaderState) {
        window.updateHomepageHeaderState();
      }
    } else {
      // currently closed → about to open
      document.body.classList.add('menu-drawer-open');

      if (isMobile) {
        document.body.classList.add('homepage-header-past-hero');
      }
    }
  });
});

/*MENU DRAWER MEDIA*/
document.addEventListener('DOMContentLoaded', function () {
  function getLocalePrefix() {
    const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    return match ? '/' + match[1] : '';
  }

  const localePrefix = getLocalePrefix();
  console.log(localePrefix);
  const mediaPanel = document.querySelector('.menu-drawer__media-panel');
  const mediaDataItems = document.querySelectorAll('.menu-drawer__media-item');

  if (!mediaPanel || !mediaDataItems.length) return;

  const defaultMediaHTML = mediaPanel.innerHTML;

  function getMediaByHandle(handle) {
    return Array.from(
      document.querySelectorAll(
        `.menu-drawer__media-item[data-menu-handle="${CSS.escape(handle)}"]`
      )
    );
  }

  function updateMenuMedia(handle) {
    const mediaItems = getMediaByHandle(handle);

    if (!mediaItems.length) {
      console.warn('No menu media found for handle:', handle);
      return;
    }

    const gridClass = mediaItems.length > 1
      ? 'menu-drawer__custom-media-grid multiple-media'
      : 'menu-drawer__custom-media-grid';

    let mediaHTML = `<div class="${gridClass}">`;

    mediaItems.forEach(function (mediaItem) {
      const image = mediaItem.dataset.image || '';
      const anchorText = mediaItem.dataset.anchorText || '';
      // const anchorUrl = mediaItem.dataset.anchorUrl || '#';
      const rawUrl = mediaItem.dataset.anchorFallbackurl || '#';
      const anchorUrl = rawUrl !== '#' ? localePrefix + rawUrl : rawUrl;

      if (!image) return;

      mediaHTML += `
        <div class="menu-drawer__custom-media">
          <a href="${anchorUrl}" class="menu-drawer__custom-media-link ">
            <img
              src="${image}"
              alt="${anchorText}"
              class="menu-drawer__custom-media-image"
              loading="lazy"
            >
            ${anchorText ? `<span class="menu-drawer__custom-media-label">${anchorText}</span>` : ''}
          </a>
        </div>
      `;
    });

    mediaHTML += '</div>';

    mediaPanel.innerHTML = mediaHTML;
  }

  function resetMenuMedia() {
    mediaPanel.innerHTML = defaultMediaHTML;
  }

  document.addEventListener('click', function (event) {
    const backOrCloseButton = event.target.closest(
      '.menu-drawer__close-button, .menu-drawer__back-button, button[name="close"], button[aria-label="Close"], button[aria-label="Back"]'
    );

    if (backOrCloseButton) {
      resetMenuMedia();
      return;
    }

    const trigger = event.target.closest('[data-menu-handle]');

    if (!trigger) return;

    const handle = trigger.dataset.menuHandle;

    if (!handle) return;

    updateMenuMedia(handle);
  });
});

/*MENU DRAWER THIRD LEVEL MENU*/
document.addEventListener('DOMContentLoaded', function () {
  const drawers = document.querySelectorAll('header-drawer');

  drawers.forEach(function (drawer) {
    const mediaPanel = drawer.querySelector('.menu-drawer__media-panel');
    const mediaData = drawer.querySelector('.menu-drawer__media-data');
    const defaultMedia = drawer.querySelector('.menu-media-container--default');

    function updateDrawerThirdLevelClass(scope) {
      const menuDrawer = scope.querySelector('.menu-drawer');

      if (!menuDrawer) return;

      const hasActiveThirdLevel = scope.querySelector('.third-level-submenu.is-active');

      menuDrawer.classList.toggle('is-third-level-active', !!hasActiveThirdLevel);
    }

    function updateMediaPanel(menuHandle) {
      console.log('Clicked menu handle:', menuHandle);
      console.log('Media panel found:', mediaPanel);
      console.log('Media data found:', mediaData);

      if (!mediaPanel || !mediaData || !menuHandle) return;

      const mediaItems = Array.from(
        mediaData.querySelectorAll(
          '.menu-drawer__media-item[data-menu-handle="' + CSS.escape(menuHandle) + '"]'
        )
      );

      console.log('Matched media items:', mediaItems);

      if (!mediaItems.length) {
        if (defaultMedia) {
          mediaPanel.innerHTML = '';
          mediaPanel.appendChild(defaultMedia.cloneNode(true));
        }

        return;
      }

      let mediaHtml = '<div class="menu-media-container-grid">';

      mediaItems.forEach(function (mediaItem) {
        const image = mediaItem.getAttribute('data-image');
        const anchorText = mediaItem.getAttribute('data-anchor-text') || '';
        const anchorUrl = mediaItem.getAttribute('data-anchor-url') || '#';
        const url = mediaItem.getAttribute('data-anchor-fallbackurl') || '#';

        mediaHtml += `
          <div class="menu-media-container menu-media-container--dynamic ${!image ? 'menu-media-container--empty' : ''}">
            ${
              image
                ? `<img
                    src="${image}"
                    alt="${anchorText}"
                    loading="lazy"
                    class="menu-media-container__image"
                  >`
                : ''
            }

            ${
              anchorText
                ? `<a href="${url}" class="menu-media-container__link">
                    ${anchorText}
                  </a>`
                : ''
            }
          </div>
        `;
      });

      mediaHtml += '</div>';

      mediaPanel.innerHTML = mediaHtml;
    }

    function closeAllThirdLevel(scope) {
      const activeItems = scope.querySelectorAll('.menu-drawer__list-item.is-third-level-open');
      const activeSubmenus = scope.querySelectorAll('.third-level-submenu.is-active');
      const activeLinks = scope.querySelectorAll('.third-level-menu.is-active');
      const closeButtons = scope.querySelectorAll('.menu-drawer__close-third-button.is-visible');

      activeItems.forEach(function (item) {
        item.classList.remove('is-third-level-open');
      });

      activeSubmenus.forEach(function (submenu) {
        submenu.classList.remove('is-active');
        submenu.setAttribute('aria-hidden', 'true');
      });

      activeLinks.forEach(function (link) {
        link.classList.remove('is-active');
        link.setAttribute('aria-expanded', 'false');
      });

      closeButtons.forEach(function (button) {
        button.classList.remove('is-visible');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-hidden', 'true');
        button.hidden = true;
      });

      updateDrawerThirdLevelClass(drawer);
    }

    drawer.addEventListener('click', function (event) {
      const backButton = event.target.closest('.menu-drawer__back-button');

      if (backButton) {
        const menuDrawer = drawer.querySelector('.menu-drawer');

        if (menuDrawer) {
          menuDrawer.classList.remove('is-third-level-active');
        }

        closeAllThirdLevel(drawer);
        return;
      }

      const thirdLevelLink = event.target.closest('.third-level-menu');

      if (thirdLevelLink) {
        const href = thirdLevelLink.getAttribute('href');
        const isHashLink = href && href.trim().endsWith('#');

        if (!isHashLink) return;

        event.preventDefault();

        const listItem = thirdLevelLink.closest('.menu-drawer__list-item');
        const submenu = listItem ? listItem.querySelector('.third-level-submenu') : null;
        const currentDrawerSubmenu = thirdLevelLink.closest('.menu-drawer__submenu');
        const closeThirdButton = currentDrawerSubmenu
          ? currentDrawerSubmenu.querySelector('.menu-drawer__close-third-button')
          : null;

        if (!submenu || !currentDrawerSubmenu || !closeThirdButton) return;

        closeAllThirdLevel(currentDrawerSubmenu);

        listItem.classList.add('is-third-level-open');

        submenu.classList.add('is-active');
        submenu.setAttribute('aria-hidden', 'false');

        thirdLevelLink.classList.add('is-active');
        thirdLevelLink.setAttribute('aria-expanded', 'true');

        closeThirdButton.hidden = false;
        closeThirdButton.classList.add('is-visible');
        closeThirdButton.setAttribute('aria-expanded', 'true');
        closeThirdButton.setAttribute('aria-hidden', 'false');

        updateDrawerThirdLevelClass(drawer);

        const menuTitle = thirdLevelLink.getAttribute('data-menu-title') || thirdLevelLink.textContent.trim();
        const buttonText = closeThirdButton.querySelector('.menu-drawer__menu-item-text');

        if (buttonText && menuTitle) {
          buttonText.textContent = menuTitle;
        }

        const menuHandle = thirdLevelLink.getAttribute('data-menu-handle');

        if (menuHandle) {
          updateMediaPanel(menuHandle);
        }

        return;
      }

      const closeThirdButton = event.target.closest('.menu-drawer__close-third-button');

      if (closeThirdButton) {
        event.preventDefault();

        const currentDrawerSubmenu = closeThirdButton.closest('.menu-drawer__submenu');
        const parentMenuHandle = closeThirdButton.getAttribute('data-menu-handle');

        if (currentDrawerSubmenu) {
          closeAllThirdLevel(currentDrawerSubmenu);
        }

        if (parentMenuHandle) {
          updateMediaPanel(parentMenuHandle);
        }

        updateDrawerThirdLevelClass(drawer);
      }
    });
  });
});

/* CARD IMAGE SLIDE CONTROLS */
(() => {
  const SLIDER_SELECTOR =
    '.product-card slideshow-component';

  /**
   * Initialize one product-card slideshow.
   */
  function initializeProductCardSlider(slideshow) {
    if (!(slideshow instanceof HTMLElement)) return;

    if (
      slideshow.dataset.productCardSliderInitialized ===
      'true'
    ) {
      return;
    }

    const scroller =
      slideshow.querySelector(
        'slideshow-slides[ref="scroller"]'
      ) ||
      slideshow.querySelector('slideshow-slides') ||
      slideshow.querySelector('[ref="scroller"]');

    const slides = Array.from(
      slideshow.querySelectorAll('slideshow-slide')
    );

    if (!scroller || slides.length <= 1) {
      return;
    }

    slideshow.dataset.productCardSliderInitialized =
      'true';

    let currentIndex = 0;

    /*
     * Remove any incomplete controls before rebuilding.
     * This also prevents duplicated arrows.
     */
    slideshow
      .querySelectorAll(
        '.product-card-slider-arrow, ' +
          '.product-card-slider-dots'
      )
      .forEach((element) => element.remove());

    const prevButton =
      document.createElement('button');

    prevButton.className =
      'product-card-slider-arrow ' +
      'product-card-slider-arrow--prev';

    prevButton.type = 'button';
    prevButton.setAttribute(
      'aria-label',
      'Previous image'
    );

    prevButton.innerHTML = `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="5"
        height="9"
        viewBox="0 0 5 9"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M4.60938 0.217041C4.34049 -0.0724244 3.88819 -0.0721585 3.61914 0.217041L0.189453 3.9104C-0.0636735 4.18309 -0.063652 4.61621 0.189453 4.88892L3.61914 8.58228C3.88815 8.87192 4.34036 8.87192 4.60938 8.58228C4.86216 8.30958 4.86232 7.87635 4.60938 7.60376L1.63379 4.39966L4.60938 1.19556C4.86206 0.922795 4.86243 0.489564 4.60938 0.217041Z"
          fill="rgb(137 146 160)"
        />
      </svg>
    `;

    const nextButton =
      document.createElement('button');

    nextButton.className =
      'product-card-slider-arrow ' +
      'product-card-slider-arrow--next';

    nextButton.type = 'button';
    nextButton.setAttribute(
      'aria-label',
      'Next image'
    );

    nextButton.innerHTML = `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="5"
        height="9"
        viewBox="0 0 5 9"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M0.189453 0.217041C0.441579 -0.0543714 0.854675 -0.0710973 1.12695 0.16626L1.17969 0.217041L4.60938 3.9104C4.8625 4.18309 4.86247 4.61621 4.60938 4.88892L1.17969 8.58228C0.910676 8.87192 0.458465 8.87192 0.189453 8.58228C-0.0633227 8.30958 -0.0634916 7.87635 0.189453 7.60376L3.16406 4.39966L0.189453 1.19556C-0.0632139 0.922794 -0.0636002 0.489559 0.189453 0.217041Z"
          fill="rgb(137 146 160)"
        />
      </svg>
    `;

    const dotsWrapper =
      document.createElement('div');

    dotsWrapper.className =
      'product-card-slider-dots';

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');

      dot.className =
        'product-card-slider-dot';

      dot.type = 'button';

      dot.setAttribute(
        'aria-label',
        `Go to image ${index + 1}`
      );

      if (index === 0) {
        dot.classList.add('is-active');
      }

      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        goToSlide(index);
      });

      dotsWrapper.appendChild(dot);
    });

    slideshow.appendChild(prevButton);
    slideshow.appendChild(nextButton);
    slideshow.appendChild(dotsWrapper);

    const dots = Array.from(
      dotsWrapper.querySelectorAll(
        '.product-card-slider-dot'
      )
    );

    function updateActiveState(index) {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;

        slide.classList.toggle(
          'is-active',
          isActive
        );

        slide.setAttribute(
          'aria-hidden',
          isActive ? 'false' : 'true'
        );
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle(
          'is-active',
          dotIndex === index
        );
      });
    }

    function goToSlide(index) {
      if (index < 0) {
        currentIndex = slides.length - 1;
      } else if (index >= slides.length) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }

      const targetSlide = slides[currentIndex];

      if (!targetSlide) return;

      scroller.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
      });

      updateActiveState(currentIndex);
    }

    prevButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        goToSlide(currentIndex - 1);
      }
    );

    nextButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        goToSlide(currentIndex + 1);
      }
    );

    let scrollTimer = null;

    scroller.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);

      scrollTimer = window.setTimeout(() => {
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(
            scroller.scrollLeft - slide.offsetLeft
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        currentIndex = closestIndex;
        updateActiveState(currentIndex);
      }, 100);
    });

    updateActiveState(0);
  }

  /**
   * Initialize all sliders inside a supplied element.
   */
  function initializeProductCardSliders(
    root = document
  ) {
    if (
      root instanceof Element &&
      root.matches(SLIDER_SELECTOR)
    ) {
      initializeProductCardSlider(root);
    }

    root
      .querySelectorAll?.(SLIDER_SELECTOR)
      .forEach(initializeProductCardSlider);
  }

  /**
   * Watch Load more and filter/AJAX updates.
   */
  function observeProductGridChanges() {
    const resultsList =
      document.querySelector('results-list');

    if (!resultsList) return;

    const observer = new MutationObserver(
      (mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;

            initializeProductCardSliders(node);
          });
        });
      }
    );

    observer.observe(resultsList, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    initializeProductCardSliders(document);
    observeProductGridChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

  /**
   * Shopify theme-editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeProductCardSliders(event.target);
    }
  );
})();

document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('product-card, .product-card');

  productCards.forEach(function (card) {
    const defaultMedia = card.querySelector('.product-media');
    const defaultImg = defaultMedia ? defaultMedia.querySelector('img') : null;

    if (!defaultImg) return;

    card.dataset.defaultImageSrc = defaultImg.getAttribute('src') || '';
    card.dataset.defaultImageSrcset = defaultImg.getAttribute('srcset') || '';
    card.dataset.defaultImageSizes = defaultImg.getAttribute('sizes') || '';
    card.dataset.defaultMediaId = defaultMedia.getAttribute('data-media-id') || '';

    function resetToDefaultImage() {
      const currentMedia = card.querySelector('.product-media');
      const currentImg = currentMedia ? currentMedia.querySelector('img') : null;

      if (!currentImg) return;

      if (card.dataset.defaultImageSrc) {
        currentImg.setAttribute('src', card.dataset.defaultImageSrc);
      }

      if (card.dataset.defaultImageSrcset) {
        currentImg.setAttribute('srcset', card.dataset.defaultImageSrcset);
      } else {
        currentImg.removeAttribute('srcset');
      }

      if (card.dataset.defaultImageSizes) {
        currentImg.setAttribute('sizes', card.dataset.defaultImageSizes);
      }

      if (card.dataset.defaultMediaId) {
        currentMedia.setAttribute('data-media-id', card.dataset.defaultMediaId);
      }

      card.classList.remove('is-hovered', 'is-swapped', 'has-hover-image');
    }

    card.addEventListener('mouseleave', resetToDefaultImage);
    card.addEventListener('mouseout', function (event) {
      if (!card.contains(event.relatedTarget)) {
        resetToDefaultImage();
      }
    });
  });
});

/* SLIDE ARROW */
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product-information__media');
  const slider = gallery?.querySelector('slideshow-slides');
  const controls = gallery?.querySelector('slideshow-controls');

  if (!gallery || !slider || !controls) return;
  if (controls.querySelector('.custom-gallery-arrows')) return;

  const arrows = document.createElement('div');
  arrows.className = 'custom-gallery-arrows';

  arrows.innerHTML = `
    <button class="custom-gallery-arrow custom-gallery-arrow--prev" type="button" aria-label="Previous image">
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9" fill="none">
        <path d="M4.60938 0.217041C4.34049 -0.0724244 3.88819 -0.0721585 3.61914 0.217041L0.189453 3.9104C-0.0636735 4.18309 -0.063652 4.61621 0.189453 4.88892L3.61914 8.58228C3.88815 8.87192 4.34036 8.87192 4.60938 8.58228C4.86216 8.30958 4.86232 7.87635 4.60938 7.60376L1.63379 4.39966L4.60938 1.19556C4.86206 0.922795 4.86243 0.489564 4.60938 0.217041ZM4.35254 7.9231V7.92407C4.34222 7.90714 4.33015 7.89108 4.31641 7.87622V7.87524C4.33011 7.89 4.34223 7.90627 4.35254 7.9231Z" fill="#B8C4D4"/>
      </svg>
    </button>

    <button class="custom-gallery-arrow custom-gallery-arrow--next" type="button" aria-label="Next image">
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9" fill="none">
        <path d="M0.189453 0.217041C0.441579 -0.0543714 0.854675 -0.0710973 1.12695 0.16626L1.17969 0.217041L4.60938 3.9104C4.8625 4.18309 4.86247 4.61621 4.60938 4.88892L1.17969 8.58228C0.910676 8.87192 0.458465 8.87192 0.189453 8.58228C-0.0633227 8.30958 -0.0634916 7.87635 0.189453 7.60376L3.16406 4.39966L0.189453 1.19556C-0.0632139 0.922794 -0.0636002 0.489559 0.189453 0.217041Z" fill="#B8C4D4"/>
      </svg>
    </button>
  `;

  controls.appendChild(arrows);

  const slides = Array.from(slider.querySelectorAll('slideshow-slide'));
  const prev = arrows.querySelector('.custom-gallery-arrow--prev');
  const next = arrows.querySelector('.custom-gallery-arrow--next');

  function getActiveIndex() {
    const sliderLeft = slider.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - sliderLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function goToSlide(index) {
    const target = slides[index];
    if (!target) return;

    slider.scrollTo({
      left: target.offsetLeft,
      behavior: 'smooth'
    });
  }

  prev.addEventListener('click', () => {
    goToSlide(Math.max(getActiveIndex() - 1, 0));
  });

  next.addEventListener('click', () => {
    goToSlide(Math.min(getActiveIndex() + 1, slides.length - 1));
  });
});

// Wishlist on quick add to cart
function renderManualWishlistIntoNotifyDrawer() {
  const drawer = document.querySelector('.nm-wishlist-drawer');
  if (!drawer) return;

  const drawerBody = drawer.querySelector('.nm-wishlist-drawer-body');
  if (!drawerBody) return;

  let customerData = {};

  try {
    customerData = JSON.parse(localStorage.getItem('NM_customerData')) || {};
  } catch (error) {
    customerData = {};
  }

  const items = customerData?.wishlists?.[0]?.items || [];

  if (!items.length) return;

  drawerBody.classList.remove('nm-wishlist-empty-state');

  drawerBody.innerHTML = items.map((item) => {
    const handle = item.product_handle || '';
    const title = handle.replace(/-/g, ' ');

    return `
      <div class="nm-manual-wishlist-item" data-product-id="${item.product_id}">
        <a href="/products/${handle}">
          ${title}
        </a>
      </div>
    `;
  }).join('');
}

document.addEventListener('click', function (event) {
  if (!event.target.closest('.nm-wishlist-open-list-button')) return;

  setTimeout(function () {
    renderManualWishlistIntoNotifyDrawer();
  }, 300);
});

// Wishlist in menu
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.custom-header-wishlist');

  if (!trigger) return;

  event.preventDefault();

  const nmButton = document.querySelector('.nm-wishlist-open-list-button');

  if (nmButton) {
    nmButton.click();
  }
});

// Notify Me Single Product
if (window.location.hash === '#notify') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.querySelector('.restock-alerts-notify-button')?.click();
    }, 800); // give Hengam time to initialize
  });
}


// Logo - header transparent/white transition
document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const header = document.querySelector('header-component#header-component');
  const main = document.querySelector('#MainContent');

  if (!body.classList.contains('page-index') || !header || !main) return;

  const hero =
    main.querySelector('.shopify-section:first-child') ||
    main.firstElementChild;

  if (!hero) return;

  // Cache hero bottom position after layout settles — avoids forced reflow on every scroll tick
  let heroCachedBottom = null;
  let ticking = false;

  function cacheHeroDimensions() {
    const scrollY = window.scrollY || window.pageYOffset;
    const heroTop = hero.getBoundingClientRect().top + scrollY;
    heroCachedBottom = heroTop + hero.offsetHeight;
  }

  function updateHomepageHeaderState() {
    const scrollY = window.scrollY || window.pageYOffset;
    const headerHeight = header.offsetHeight || 80;

    if (heroCachedBottom === null) cacheHeroDimensions();

    const isScrolled = scrollY > 10;
    const isPastHero = scrollY + headerHeight >= heroCachedBottom;
    const isWithinHeroScrolled = isScrolled && !isPastHero;

    body.classList.toggle('homepage-header-scrolled-inside-hero', isWithinHeroScrolled);
    body.classList.toggle('homepage-header-past-hero', isPastHero);
    header.classList.toggle('is-within-hero-scrolled', isWithinHeroScrolled);
    header.classList.toggle('is-past-hero', isPastHero);

    ticking = false;
  }

  function requestHeaderUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(updateHomepageHeaderState);
      ticking = true;
    }
  }

  // Cache dimensions after load when layout is fully stable
  window.addEventListener('load', function () {
    cacheHeroDimensions();
    updateHomepageHeaderState();
  });

  // Recache on resize since hero height can change
  window.addEventListener('resize', function () {
    heroCachedBottom = null;
    requestHeaderUpdate();
  });

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });

  // Expose for menu drawer usage
  window.updateHomepageHeaderState = updateHomepageHeaderState;

  // Initial call — safe at scrollY 0, no class toggling expected
  updateHomepageHeaderState();
});

// Scroll smooth
document.addEventListener('DOMContentLoaded', function () {
  const smoothScrollLinks = document.querySelectorAll('.smooth-scroll-link');

  function animateScrollTo(targetY, duration) {
    const startY = window.scrollY;
    const distance = targetY - startY;
    const startTime = performance.now();

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function animation(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeInOutQuad(progress);

      window.scrollTo(0, startY + distance * easedProgress);

      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  smoothScrollLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      const href = link.getAttribute('href');

      if (!href || !href.startsWith('#') || href.length <= 1) return;

      const target = document.querySelector(href);

      if (!target) return;

      event.preventDefault();

      const header = document.querySelector('.site-header, .header, sticky-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const targetY = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      animateScrollTo(targetY, 500);
    });
  });
});

// Size Chart Modal
(function () {
  'use strict';

  const BODY_OPEN_CLASS = 'size-guide-modal-open';
  const MODAL_SELECTOR = '.size-guide-modal';

  /**
   * Find the correct size-guide modal from a trigger,
   * close button, modal element, or nearby product section.
   */
  function getModalFromElement(source) {
    if (!source) {
      return (
        document.querySelector(`${MODAL_SELECTOR}[open]`) ||
        document.querySelector(MODAL_SELECTOR)
      );
    }

    /*
     * Allow a selector string or modal ID to be passed.
     */
    if (typeof source === 'string') {
      try {
        const selector = source.startsWith('#')
          ? source
          : `#${source}`;

        const modal = document.querySelector(selector);

        if (modal && modal.matches(MODAL_SELECTOR)) {
          return modal;
        }
      } catch (error) {
        console.warn('Invalid size-guide modal selector:', source);
      }

      return document.querySelector(MODAL_SELECTOR);
    }

    /*
     * Support an event object.
     */
    if (source.target instanceof Element) {
      source = source.target;
    }

    if (!(source instanceof Element)) {
      return (
        document.querySelector(`${MODAL_SELECTOR}[open]`) ||
        document.querySelector(MODAL_SELECTOR)
      );
    }

    /*
     * The source itself is the modal.
     */
    if (source.matches(MODAL_SELECTOR)) {
      return source;
    }

    /*
     * The source is inside the modal.
     */
    const parentModal = source.closest(MODAL_SELECTOR);

    if (parentModal) {
      return parentModal;
    }

    /*
     * Support:
     * data-size-guide-target="#modal-id"
     * data-modal-target="#modal-id"
     * data-target="#modal-id"
     * aria-controls="modal-id"
     */
    const targetValue =
      source.getAttribute('data-size-guide-target') ||
      source.getAttribute('data-modal-target') ||
      source.getAttribute('data-target') ||
      source.getAttribute('aria-controls');

    if (targetValue) {
      try {
        const selector = targetValue.startsWith('#')
          ? targetValue
          : `#${targetValue}`;

        const targetModal = document.querySelector(selector);

        if (targetModal && targetModal.matches(MODAL_SELECTOR)) {
          return targetModal;
        }
      } catch (error) {
        console.warn(
          'Invalid size-guide target selector:',
          targetValue
        );
      }
    }

    /*
     * Find a modal inside the same product or Shopify section.
     */
    const scope = source.closest(
      [
        'product-info',
        'quick-add-modal',
        '.quick-add-modal',
        '.product',
        '.product-info',
        '.shopify-section',
        '[data-product-id]'
      ].join(',')
    );

    if (scope) {
      const scopedModal = scope.querySelector(MODAL_SELECTOR);

      if (scopedModal) {
        return scopedModal;
      }
    }

    /*
     * Final fallback.
     */
    return document.querySelector(MODAL_SELECTOR);
  }

  /**
   * Add or remove the body class depending on whether
   * any size-guide modal is currently open.
   */
  function updateSizeGuideBodyClass() {
    const hasOpenModal = Boolean(
      document.querySelector(`${MODAL_SELECTOR}[open]`)
    );

    document.body.classList.toggle(
      BODY_OPEN_CLASS,
      hasOpenModal
    );
  }

  /**
   * Open the size-guide modal.
   */
  function openSizeGuide(modal) {
    if (!modal) {
      console.warn('Size-guide modal was not found.');
      return;
    }

    try {
      if (
        modal instanceof HTMLDialogElement &&
        typeof modal.showModal === 'function'
      ) {
        if (!modal.open) {
          modal.showModal();
        }
      } else {
        modal.setAttribute('open', '');
      }

      modal.classList.add('is-open');
      document.body.classList.add(BODY_OPEN_CLASS);

      const closeButton = modal.querySelector(
        '.size-guide-modal__close'
      );

      if (closeButton) {
        requestAnimationFrame(function () {
          closeButton.focus({
            preventScroll: true
          });
        });
      }
    } catch (error) {
      /*
       * Fallback in case showModal() cannot be called.
       */
      modal.setAttribute('open', '');
      modal.classList.add('is-open');
      document.body.classList.add(BODY_OPEN_CLASS);

      console.warn(
        'Native size-guide dialog could not be opened:',
        error
      );
    }
  }

  /**
   * Close the size-guide modal.
   */
  function closeSizeGuide(modal) {
    if (!modal) {
      updateSizeGuideBodyClass();
      return;
    }

    try {
      if (
        modal instanceof HTMLDialogElement &&
        typeof modal.close === 'function' &&
        modal.open
      ) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    } catch (error) {
      modal.removeAttribute('open');

      console.warn(
        'Native size-guide dialog could not be closed:',
        error
      );
    }

    modal.classList.remove('is-open');

    /*
     * Wait until the dialog's open attribute is removed
     * before checking whether another modal is still open.
     */
    requestAnimationFrame(updateSizeGuideBodyClass);
  }

  /**
   * Handle trigger, close button, tabs, and backdrop clicks.
   */
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(
      '.size-guide-trigger'
    );

    if (trigger) {
      event.preventDefault();

      const modal = getModalFromElement(trigger);
      openSizeGuide(modal);

      return;
    }

    const closeButton = event.target.closest(
      '.size-guide-modal__close'
    );

    if (closeButton) {
      event.preventDefault();

      const modal = closeButton.closest(MODAL_SELECTOR);
      closeSizeGuide(modal);

      return;
    }

    const tab = event.target.closest('.size-guide-tab');

    if (tab) {
      event.preventDefault();

      const modal = tab.closest(MODAL_SELECTOR);

      if (!modal) {
        return;
      }

      const target = tab.dataset.tab;

      modal
        .querySelectorAll('.size-guide-tab')
        .forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

      modal
        .querySelectorAll('.size-guide-panel')
        .forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      const panel = modal.querySelector(
        `[data-panel="${CSS.escape(target || '')}"]`
      );

      if (panel) {
        panel.classList.add('is-active');
        panel.hidden = false;
      }

      return;
    }

    /*
     * Close when clicking directly on the dialog backdrop.
     */
    if (event.target.matches(MODAL_SELECTOR)) {
      closeSizeGuide(event.target);
    }
  });

  /**
   * Handle the Escape key for native dialog elements.
   */
  document.addEventListener(
    'cancel',
    function (event) {
      if (!event.target.matches(MODAL_SELECTOR)) {
        return;
      }

      event.preventDefault();
      closeSizeGuide(event.target);
    },
    true
  );

  /**
   * Keep the body class synchronized when a native dialog
   * is closed through another script.
   */
  document.addEventListener(
    'close',
    function (event) {
      if (!event.target.matches(MODAL_SELECTOR)) {
        return;
      }

      event.target.classList.remove('is-open');
      updateSizeGuideBodyClass();
    },
    true
  );

  /**
   * Public functions for inline buttons or other scripts.
   *
   * Example:
   * window.sizeGuideOpen(this);
   * window.sizeGuideClose(this);
   */
  window.sizeGuideOpen = function (source) {
    const modal = getModalFromElement(source);
    openSizeGuide(modal);
  };

  window.sizeGuideClose = function (source) {
    const modal =
      getModalFromElement(source) ||
      document.querySelector(`${MODAL_SELECTOR}[open]`) ||
      document.querySelector(MODAL_SELECTOR);

    closeSizeGuide(modal);
  };

  /**
   * Correct the body class on initial page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateSizeGuideBodyClass
    );
  } else {
    updateSizeGuideBodyClass();
  }
})();

/* WISHLIST NUMBER IN HEADER */
(function () {
    'use strict';

    const wishlistStorageKey = 'NM_customerData';

    function getWishlistCount() {
      try {
        const savedData = localStorage.getItem(wishlistStorageKey);

        if (!savedData) {
          return 0;
        }

        const customerData = JSON.parse(savedData);

        if (!Array.isArray(customerData.wishlists)) {
          return 0;
        }

        return customerData.wishlists.reduce(function (total, wishlist) {
          const items = Array.isArray(wishlist.items)
            ? wishlist.items
            : [];

          return total + items.length;
        }, 0);
      } catch (error) {
        console.warn('Unable to read wishlist count:', error);
        return 0;
      }
    }

    function updateWishlistBubble() {
      const count = getWishlistCount();

      document
        .querySelectorAll('[data-wishlist-bubble]')
        .forEach(function (bubble) {
          const countText = bubble.querySelector(
            '[data-wishlist-bubble-text]'
          );

          if (countText) {
            countText.textContent = count > 99 ? '99+' : count;
          }

          if (count > 0) {
            bubble.hidden = false;
            bubble.setAttribute('aria-hidden', 'false');
          } else {
            bubble.hidden = true;
            bubble.setAttribute('aria-hidden', 'true');
          }
        });

      document
        .querySelectorAll('.header-actions__action--wishlist')
        .forEach(function (wishlistLink) {
          wishlistLink.setAttribute(
            'aria-label',
            count === 1
              ? 'Wishlist, 1 product'
              : 'Wishlist, ' + count + ' products'
          );
        });
    }

    window.updateWishlistBubble = updateWishlistBubble;

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        updateWishlistBubble
      );
    } else {
      updateWishlistBubble();
    }

    window.addEventListener('pageshow', updateWishlistBubble);

    window.addEventListener('storage', function (event) {
      if (event.key === wishlistStorageKey) {
        updateWishlistBubble();
      }
    });

    document.addEventListener(
      'wishlist:updated',
      updateWishlistBubble
    );
  })();